export default __webpack_public_path__ + "static/media/fontawesome-webfont.bfcf94e0.ttf";